import { useCallback, useState } from "react"
import { Country } from "../entities/country"
import { countryListService } from "../services/country/countryListService"
import { useAuth } from "./useAuth"

export function useCountryListService(): {
	countryList: Country[]
	isLoading: boolean
	fetchCountryList: (filter?: Parameters<typeof countryListService>[0]) => Promise<void>
} {
	const { token } = useAuth()
	const [countryList, setCountryList] = useState<Country[]>([])
	const [isLoading, setIsLoading] = useState(false)

	const fetchCountryList = useCallback(
		async (filter: Parameters<typeof countryListService>[0] = {}) => {
			setIsLoading(true)
			const data = await countryListService(filter, token)
			setCountryList(data)
			setIsLoading(false)
		},
		[token],
	)

	return { countryList, isLoading, fetchCountryList }
}
